<div class="toggler" *ngIf="removePopup" [ngClass]="{'fadeIn': !toggleDisplay}">
  <div class="toggler-inner" *ngIf="toggleDisplay" (click)="toggle()">
    <p class=""  >
        <!-- <i class="fas fa-comment-alt icon-msg"></i> -->
        {{"Home.Newsletter" | translate}}
    </p>

  </div>
  <div class="newsletter animate slideLeft" *ngIf="!toggleDisplay">
    <div class="newsletter-content">
      <button class="close-btn" (click)="toggleOff()"><i class="fas fa-times"></i></button>
      <h3 style="color: #3265B1">{{"Home.NewsTitle" | translate}}</h3>
      <h3 style="margin-bottom: .5em; color: #000;">{{"Home.NewsSub" | translate}}</h3>
      <div class="buttons">
        <div><button type="button" routerLink="news-information/newsletters" (click)="toggleOff()"  class="btn btn-primary">{{"Home.Sub" | translate}}</button></div>
        <div><button type="button" (click)="toggle()" class="btn btn-light">{{"Home.Later" | translate}}</button></div>
      </div>
    </div>
  </div>
</div>
